import ContractsMileageCargoCompanyDetailsResponse from "../../../../api/raily/contracts/mileage/cargo-company-details/contracts-mileage-cargo-company-details.response";
import ContractsMileageCargoCompanyDetails from "./contracts-mileage-cargo-company-details";

const create = (
  response: ContractsMileageCargoCompanyDetailsResponse,
): ContractsMileageCargoCompanyDetails => {
  return {
    distanceRateCarGt900cm3: response.data.distanceRateCarGt900cm3,
    distanceRateCarLe900cm3: response.data.distanceRateCarLe900cm3,
    distanceRateCompanyVehicle: response.data.distanceRateCompanyVehicle,
    distanceRateMoped: response.data.distanceRateMoped,
    distanceRateMotorcycle: response.data.distanceRateMotorcycle,
  };
};

const contractsMileageCargoCompanyDetailsFactory = {
  create,
};

export default contractsMileageCargoCompanyDetailsFactory;
